import styled from 'styled-components';

import { Text, Flex, spaces } from '@electricjs/arc';

import { MultiLineEllipsisText } from '@common';

import { SimpleDynamicProductProperty } from '@/types/products';

import { getDynamicPropertyDisplayValue } from '../../utils';
import PurchasedForChip from '../PurchasedForChip';
import { ItemImage } from '../ItemImage';

type ProductDescriptionProps = {
  name: string;
  image?: string;
  dynamicProperties?: SimpleDynamicProductProperty[];
  groupNames?: string[];
  isCondensed?: boolean;
};

const StyledDynamicPropertiesList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;

const PurchaseForChipContainer = styled.div<{ $isCondensed?: boolean }>`
  position: absolute;
  top: ${({ $isCondensed }) => ($isCondensed ? '12px' : '16px')};
  left: ${({ $isCondensed }) => ($isCondensed ? '12px' : '16px')};
`;

export const ProductDescription = ({
  name,
  image,
  dynamicProperties,
  groupNames,
  isCondensed,
}: ProductDescriptionProps) => {
  return (
    <Flex
      width="100%"
      alignItems="center"
      justifyContent="center"
      vertical
      rowGap={spaces.space_m}>
      <PurchaseForChipContainer $isCondensed={isCondensed}>
        <PurchasedForChip groupNames={groupNames} />
      </PurchaseForChipContainer>

      <ItemImage
        src={image}
        alt={name}
        size={isCondensed ? 'condensedCardSize' : 'regularCardSize'}
      />

      <Flex vertical width="100%" rowGap={spaces.space_xs}>
        {isCondensed ? (
          <MultiLineEllipsisText variant="body-2" $maxLines={2} title={name}>
            {name}
          </MultiLineEllipsisText>
        ) : (
          <Text variant="label-large" truncateAt="100%" title={name}>
            {name}
          </Text>
        )}
        {dynamicProperties && !isCondensed && (
          <StyledDynamicPropertiesList>
            {dynamicProperties?.map(property => (
              <li key={property.name}>
                <Text truncateAt="100%">
                  {`${property.displayName || property.name}: ${getDynamicPropertyDisplayValue(property.slug, property.value)}`}
                </Text>
              </li>
            ))}
          </StyledDynamicPropertiesList>
        )}
      </Flex>
    </Flex>
  );
};
